// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ne-0";
export var assigneeDetails = "_ne-1";
export var assigneeInfo = "_ne-2";
export var dropdownContainer = "_ne-4";
export var dropdownImage = "_ne-5";
export var editAssigneeInfo = "_ne-3";
export var editAssigneeModalContainer = "_ne-6";
export var hidden = "_ne-8";
export var input = "_ne-7";